<template>
  <div class="background">
    <!-- <div class="text-center mt-4 center">
      <<v-alert type="warning" max-width="650" class="d-md-block center d-none"
        >Le site est toujours en cours de développement, il sera disponible
        rapidement !</v-alert
      > 
    </div>-->
    <v-container v-if="!isFetching">
      <v-row>
        <v-col cols="2" class="d-none d-xl-flex"> </v-col>
        <v-col>
          <v-row>
            <v-col cols="12" md="6">
              <v-card elevation="2" min-height="750" class="px-4 py-4">
                <Bio :user="user" :adminMod="this.adminMod" />
                <v-divider
                  class="lighten-1 mt-5 mb-3 ml-0 mr-0"
                  v-bind:class="schoolColor"
                ></v-divider>
                <StatsProfile :user="user" />
                <div v-if="user.is_teacher">
                  <v-divider
                    class="lighten-1 mt-5 mb-3 ml-0 mr-0"
                    v-bind:class="schoolColor"
                  ></v-divider>
                  <BtnAddCourse :user="user" :isAdminMode="adminMod" />
                  <!-- <v-btn
                    color="warning"
                    class="mt-4"
                    large
                    @click="dialog_edit_teacher = true"
                  >
                    <v-icon class="mr-1">mdi-pencil</v-icon> Modifier
                    préférences
                  </v-btn> -->
                  <v-dialog v-model="dialog_edit_teacher" width="600">
                    <DialogTeacherProfiles
                      :user="user"
                      @close="dialog_edit_teacher = false"
                    />
                  </v-dialog>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card
                height="750"
                class="overflow-y-auto pa-2 mb-8"
                v-scroll.self="onScroll"
              >
                <CourseApplicationViewer :user="user" :adminMod="adminMod" />
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2" class="d-none d-xl-flex"> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Bio from "../components/Bio.vue";
import StatsProfile from "../components/StatsProfile.vue";
import CourseApplicationViewer from "../components/CourseApplicationViewer.vue";
import DialogTeacherProfiles from "../components/DialogTeacherProfiles.vue";
import BtnAddCourse from "../components/BtnAddCourse.vue";
import { mapGetters } from "vuex";
// import dayjs from "dayjs";

export default {
  name: "Profile",

  components: {
    DialogTeacherProfiles,
    Bio,
    StatsProfile,
    CourseApplicationViewer,
    BtnAddCourse,
  },

  data: () => ({
    isFetching: true,
    adminMod: false,
    dialog_edit_teacher: false,

    scrollInvoked: 0,
  }),
  computed: {
    ...mapGetters({
      currentUser: "user/getUser",
      specificUser: "admin/getSpecificUser",
    }),
    schoolColor: function () {
      return this.user.school;
    },
    user: function () {
      if (this.$route.params.memberid == undefined) {
        return this.currentUser;
      } else {
        return this.specificUser;
      }
    },
  },
  methods: {
    returnSchool() {
      return this.user.school;
    },
    onScroll() {
      this.scrollInvoked++;
    },
  },
  beforeMount() {
    if (this.$route.params.memberid == undefined) {
      this.isFetching = false;
    } else {
      this.adminMod = true;
      this.$store
        .dispatch("admin/getUserById", this.$route.params.memberid)
        .finally(() => {
          this.isFetching = false;
        });
    }
  },
  mounted() {
    //#region POPUP RECRUTEMENT IT 1
    const popIT = () => {
      if (
        localStorage.getItem("popup-recrutement-it-1") == null ||
        parseInt(localStorage.getItem("popup-recrutement-it-1")) <= 2
      ) {
        this.$swal
          .fire({
            title:
              "<p style='font-size: 3em'>💻</p><p style='font-size: 0.99em; margin: 15px 0px'>⚠️LéoLearning a besoin de toi⚠️</p>",
            html: `
             <div style="margin-bottom: 15px">
      Ce site, c’est le cœur de l’association Léolearning 💛<br>
      Mais c'est un projet qui demande beaucoup de temps.
    </div>
    <div style="margin-bottom: 15px">
      💡 Tu aimes coder, ou tu es juste curieux.se ?  <br>
      <b>Rejoins l'équipe IT !</b>
    </div>
    <div style="margin-bottom: 15px">
      💬 Écris-moi sur Discord (<b>pierolb</b>) ou sur <a href="https://www.instagram.com/p/DOdXHCSiAEy/?img_index=1" target="_blank">Instagram</a>
    </div>
    <i>Sans le site, pas de tutorat🥺</i>`,
            confirmButtonText: "OK",
            confirmButtonColor: "#ca8c05",
            showCloseButton: true,
            iconColor: "#ca8c05",
          })
          .then(() => {
            if (localStorage.getItem("popup-recrutement-it-1") == null) {
              localStorage.setItem("popup-recrutement-it-1", "1");
            } else {
              localStorage.setItem(
                "popup-recrutement-it-1",
                (
                  parseInt(localStorage.getItem("popup-recrutement-it-1")) + 1
                ).toString()
              );
            }
          });
      }
    };
    //#endregion
    //#region POPUP RECRUTEMENT V2
    if (
      localStorage.getItem("popup-recrutement3") == null ||
      parseInt(localStorage.getItem("popup-recrutement3")) <= 2
    ) {
      this.$swal
        .fire({
          title:
            "<span style='font-size: 3em'>🔥</span><br>LéoLearning recrute !",
          html: `
          <div style='margin-bottom: 15px'>Si tu as déjà bénéficié du contenu de LéoLearning (tutorat ou annales) et que tu aimerais aider à ton tour : </div>
          <div style='text-align: left; margin-bottom: 15px'>
            <div>👉 <strong>Deviens tuteur</strong> : partage tes connaissances, développe tes compétences et fait de belles rencontres</div>
            <div>👉 <strong>Rejoins le bureau élargi</strong> : </div>
            <div style='width: 100%; display:flex;'>
              <div style='width: 100%; text-align: center'>Com 🎨</div>
              <div style='width: 100%; text-align: center'>Event 🎉</div>
              <div style='width: 100%; text-align: center'>Orga 📑</div>
            </div>
          </div>
          <div style='font-size: 1rem'><i>Pour plus de détails : 🔗<a href="https://www.instagram.com/p/DOdXHCSiAEy/?img_index=1" target="_blank">Instagram</a></i></div>`,
          confirmButtonText:
            "<a style='text-decoration: none; color: #ffffff; display: flex; align-items: center' ><span style='font-size: 1.7rem'>🦭</span> Rejoins la famille LéoLearning <span style='font-size: 1.7rem'>🦭</span></a>",
          confirmButtonColor: "#ca8c05",
          showCloseButton: true,
          iconColor: "#ca8c05",
        })
        .then((okay) => {
          if (okay.isConfirmed) {
            window.open(
              "https://forms.office.com/Pages/ResponsePage.aspx?id=rrzuiObW9067pEw09MLV4Dg9aQSRqBhDks3DMNEn5IFUNjdMQTA3TEZCVk5MT0xLTEcyREI1Nlc3VS4u",
              "_blank"
            );
          }
          if (localStorage.getItem("popup-recrutement3") == null) {
            localStorage.setItem("popup-recrutement3", "1");
          } else {
            localStorage.setItem(
              "popup-recrutement3",
              (
                parseInt(localStorage.getItem("popup-recrutement3")) + 1
              ).toString()
            );
          }
          popIT();
        });
    } else {
      popIT();
    }
    //#endregion
    //#region POPUP RECRUTEMENT V1
    // if ([null, "1", "2"].includes(localStorage.getItem("popup-1"))) {
    //   this.$swal
    //     .fire({
    //       icon: "info",
    //       title: "LéoLearning recrute ! ",
    //       html: "Tu veux t’investir dans une association d’entraide entre étudiants ? <br/> Que ce soit pour créer des visuels, organiser des évènements ou aider pour le tutorat, n'hésite pas et rejoins-nous !!",
    //       confirmButtonText:
    //         "<a style='text-decoration: none; color: #ffffff' >GO !!</a>",
    //       confirmButtonColor: "#ca8c05",
    //       iconColor: "#ca8c05",
    //     })
    //     .then((okay) => {
    //       console.log(okay);
    //       if (okay.isConfirmed) {
    //         window.open("https://forms.gle/6x9HB5tPNK3iYU8D6", "_blank");
    //       }
    //     });
    //   switch (localStorage.getItem("popup-1")) {
    //     case null:
    //       localStorage.setItem("popup-1", "1");
    //       break;
    //     case "1":
    //       localStorage.setItem("popup-1", "2");
    //       break;
    //     case "2":
    //       localStorage.setItem("popup-1", "3");
    //       break;
    //   }
    // }
    //#endregion
    //#region POPUP NOEL
    // if (
    //   !localStorage.getItem("popup-noel") ||
    //   dayjs().format("YYYY-MM-DD") !=
    //     dayjs(localStorage.getItem("popup-noel")).format("YYYY-MM-DD")
    // )
    //   this.$swal
    //     .fire({
    //       title:
    //         "<label style='font-size: 3em'>🎄</label><br>LéoLearning dévoile son <label style='color: #056517'>calendrier de l'avent</label> !",
    //       html: "Tous les jours du <strong style='color: #056517'>1er au 25 décembre</strong> retrouvez<br>des <strong style='color: #056517'>quiz</strong>, des <strong style='color: #056517'>devinettes</strong> et des <strong style='color: #056517'>enigmes</strong> sur notre compte Instagram.",
    //       confirmButtonText: "Aller sur Instagram🎁",
    //       confirmButtonColor: "#BB051F",
    //       iconColor: "#BB051F",
    //       showCloseButton: true,
    //       backdrop: "rgba(194,95,95,0.4)",
    //     })
    //     .then((okay) => {
    //       if (okay.isConfirmed) {
    //         window.open("https://www.instagram.com/leolearningpulv/", "_blank");
    //       }
    //     });
    // localStorage.setItem("popup-noel", dayjs());
    //#endregion
    //#region POPUP PUB LEODATA
    // if (
    //   !localStorage.getItem("popup-noel") ||
    //   dayjs().format("YYYY-MM-DD") !=
    //     dayjs(localStorage.getItem("popup-noel")).format("YYYY-MM-DD")
    // )
    // this.$swal
    //   .fire({
    //     title: `<img src='../assets/leodata_logo.png'>
    //     <div style='margin-top: -20px'><label style='color:#0899BD'>LÉO</label><label style='color:#D11758'>DA</label><label style='color:#EF8108'>TA</label></div>`,
    //     html: `
    //       Notre plateforme d'annales pour <strong style='color:#D11758'>l'ESILV</strong> et <strong style='color:#0899BD'>l'EMLV</strong> a besoin de toi !<br><br>
    //       Si tu as gardé des <strong>sujets</strong> ou des <strong>corrections</strong>,
    //       envoie-les nous par mail <a href="mailto:leolearning@devinci.fr">leolearning@devinci.fr</a> <strong>OU</strong> sur <a href="https://www.instagram.com/direct/t/17843044025446259" target="_blank">Instagram</a>
    //       `,
    //     confirmButtonText: "OK",
    //     showCloseButton: true,
    //   })
    //   .then((okay) => {
    //     if (okay.isConfirmed) {
    //       window.open("https://www.instagram.com/leolearningpulv/", "_blank");
    //     }
    //   });
    // localStorage.setItem("popup-noel", dayjs());
    //#endregion
  },
};
</script>

<style scoped>
.background {
  background-color: #d6d6d6;
  background-image: url(../assets/bg_white_wave.png);
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  width: auto;
}

.center {
  margin: auto;
  width: 60%;
}

@media screen and (max-width: 1200px) {
  .responsive {
    display: flex;
    flex-direction: column;
  }

  .stats {
    display: flex;
    flex-direction: column;
  }
}
</style>
